import { useEffect, useState } from "react";

import { createSearchParams, useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { ExcelModule } from "../../../../misc";
import { Health, ProductServices } from "../../../../services";
import { AlertWidget, DataTableProducts, MainBoxTool } from "../../../common";
import { AlertWidgetType } from "../../../common/types";
import "./Dashboard-Products.css";
import { FormattedMessage } from "react-intl";

const DashboardProducts = (props: any) => {
  const [productsHealth, setProductsHealth] = useState<any>({});
  const [products, setProducts] = useState<any[]>([{}]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const [productSelection, setProductsSelection] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const response = await Health.GetProductsHealth();

        if (response.Status === 200) {
          setProductsHealth(response.Content);

          // console.log("RESPONSE HEALTH", response);
        }
      } catch (error) {
        console.log(error);
      }
    })();

    (async () => {
      try {
        setIsLoadingProducts(true);

        const response = await ProductServices.GetProducts();

        if (response.Status === 200) {
          // console.log("RESPONSE PRODUCTS", response);
          setProducts(response.Content);
        }

        setIsLoadingProducts(false);
      } catch (error) {
        console.log(error);

        setIsLoadingProducts(false);
      }
    })();
  }, [setProducts]);

  const onSuscribeProductsSelectionChange = (value: any) => {
    // console.log('Dashboard-Products onSuscribeProductsSelectionChange', value);

    setProductsSelection(value);
  };

  const onSuscribeDelete = (data: any) => {
    try {
      // if ((productSelection) && (productSelection.length > 0)) {
      //   console.log('Click Borrar', productSelection);
      // }
      // else {
      console.log("Click Borrar", data);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const onSuscribeDeleteGroup = (data: any) => {
    try {
      // if ((productSelection) && (productSelection.length > 0)) {
      //   console.log('Click Borrar', productSelection);
      // }
      // else {
      console.log("Click Borrar List", data);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const onSuscribeEdit = (data: any) => {
    try {
      navigate(
        {
          pathname: `edit/${data.Id}`,
          // search: createSearchParams({
          //   clothesType: clothesTypeSelect.toString(),
          //   gender: genderSelect.toString(),
          //   isUnique: uniqueSelect.toString(),
          // }).toString(),
        },
        { state: data }
      );
      // if ((productSelection) && (productSelection.length > 0)) {
      //   console.log('Click Editar', productSelection);
      // }
      // else {

      console.log("Click Editar", data);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const onSuscribeAddSizeGuide = (data: any) => {
    console.log("Click Asociar Guía", data);
  };

  const onSuscribeDownloadData = (data: any) => {
    const exportData: any[] = data && data.length > 0 ? data : products;

    try {
      // console.log('Click Download', exportData);

      if (exportData) {
        let ExportElements: any[] = new Array<any>();

        [].forEach.call(exportData, (elemento: any, indice: number) => {
          ExportElements.push({
            Modelo: elemento.Code,
            SKUs: elemento.VariantsId ? elemento.VariantsId.join(", ") : "",
            Descripcion: elemento.Description,
            Posicion: elemento.BodyArea ? elemento.BodyArea.Name : "",
            Genero: elemento.Gender ? elemento.Gender.Name : "",
            Fit: elemento.FitType ? elemento.FitType.Name : "",
            Talles: elemento.Sizes
              ? elemento.Sizes.map((element: any) => element.Name).join(", ")
              : "",
            Categorias: elemento.PlatformCategory
              ? elemento.PlatformCategory.map(
                  (element: any) => element.Name
                ).join(", ")
              : "",
            Guia: elemento.SizeGuide ? elemento.SizeGuide.Name : "",
          });
        });

        if (ExportElements && ExportElements.length > 0) {
          ExcelModule.ExportTo(
            ExportElements,
            "Productos",
            "Fitprenda_Productos"
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
    // console.log('Click Download', data);
  };

  const contentInternalMainBox = () => {
    return (
      <>
        <Col>
          <Row className="my-3">
            <Col xs={5}>
              <img
                className="dashboard-product-image-one"
                src="/img/icon-create-item.png"
                alt="Icon Item"
                width={97}
              />
            </Col>
            <Col xs={7}>
              <p className="font-fitprenda-action-description">
                <FormattedMessage
                  id="dashboard-action-description"
                  // defaultMessage="Use an example to load one product at a time."
                />
              </p>
              {/* <br className="d-xxl-block d-sm-none" /> */}
              <p className="mt-3 pt-4">
                <a
                  href="/readysize/products/create"
                  className="link-fitprenda-action"
                >
                  <FormattedMessage
                    id="ready-size-do-now"
                    defaultMessage="Hacer ahora"
                  />
                </a>
              </p>
            </Col>
          </Row>
        </Col>

        <div className="box-fitprenda-internal-separator"></div>

        <Col>
          <Row className="my-3">
            <Col xs={5}>
              <img
                className="dashboard-product-image-one"
                src="/img/icon-excel.png"
                alt="Icon Excel"
                width={97}
              />
            </Col>
            <Col xs={7}>
              <p className="font-fitprenda-action-description">
                <FormattedMessage
                  id="dashboard-excel-upload-description"
                  // defaultMessage="Utliza un archivo excel para cargar productos de forma masiva."
                />
              </p>
              <p className="mt-3">
                <a
                  href="/readysize/products/uploads"
                  className="link-fitprenda-action"
                >
                  <FormattedMessage
                    id="ready-size-do-now"
                    defaultMessage="Hacer ahora"
                  />
                </a>
              </p>
            </Col>
          </Row>
        </Col>

        <div className="box-fitprenda-internal-separator"></div>

        <Col>
          <Row className="my-3">
            <Col xs={5}>
              <img
                className="dashboard-product-image-two"
                src="/img/icon-api.png"
                alt="Icon API"
                width={97}
              />
            </Col>
            <Col xs={7}>
              <p className="font-fitprenda-action-description">
                <FormattedMessage
                  id="dashboard-automate-description"
                  // defaultMessage="Automatiza la carga y actualización de tus productos."
                />
              </p>
              <p className="mt-3">
                <a href="/readysize/charts" className="link-fitprenda-action">
                  <FormattedMessage
                    id="dashboard-products-know-more"
                    // defaultMessage="Automatiza la carga y actualización de tus productos."
                  />
                </a>
              </p>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  /* DIVS DEL MEDIO DE PRODUCTOS */

  return (
    <>
      {/* Access */}
      <Row className="justify-content-center">
        <Col className="dashboard-products-main-container" xs={8} xl={9}>
          <MainBoxTool
            title={
              <FormattedMessage
                id="dashboard-mainboxtool-title"
                defaultMessage="Carga y actualiza los productos"
              />
            }
            subtitle="dashboard-mainboxtool-subtitle"
            children={contentInternalMainBox()}
          />
        </Col>
      </Row>

      {/* Alerts */}
      <Row className="justify-content-center mt-3 px-3">
        <Col className="dashboard-products-main-sub-container" xs={8} xl={9}>
          <Row className="dashboard-product-products-container">
            <Col className="dashboard-product-products-container">
              <AlertWidget
                title="ready-size-products-withoutguide"
                values={{ count: productsHealth?.NoSizeGuide || "0" }}
                description=""
                urlLink="/readysize/products/list-wsg"
                urlText="ready-size-associate-guide"
                typeAlert={AlertWidgetType.CENTIMETER}
                includeNewLine={false}
                className="dashboard-products-alert-widget"
              />
            </Col>
            <Col className="mx-2">
              <AlertWidget
                title="dashboard-products-ProductosNoReconocidos"
                values={{ count: productsHealth?.UnknowProducts || "0" }}
                description=""
                urlLink="/readysize/products/list-nf"
                urlText="dashboard-products-Solucionar"
                typeAlert={AlertWidgetType.TSHIRT}
                includeNewLine={false}
                className="dashboard-products-alert-widget"
              />
            </Col>
            <Col>
              <AlertWidget
                title="dashboard-products-ProductosSinActividad"
                values={{ count: productsHealth?.Inactive || "0" }}
                description=""
                urlLink="/readysize/products/list-inactive"
                urlText="dashboard-products-Eliminar"
                typeAlert={AlertWidgetType.WARNING}
                includeNewLine={false}
                className="dashboard-products-alert-widget"
              />
            </Col>
          </Row>
        </Col>
      </Row>

        {/* Products */}
          {/*handlerSelectionRow={onSuscribeProductsSelectionChange}*/}
          {/*handlerDelete={onSuscribeDelete}*/}
          {/*handlerEdit={onSuscribeEdit}*/}
          {/*handlerDeleteGroup={onSuscribeDeleteGroup}*/}
          {/*handlerAddSizeGuideGroup={onSuscribeAddSizeGuide}*/}
      <Row className="justify-content-center mt-5">
        <Col>
          <DataTableProducts
            products={products}
            isLoading={isLoadingProducts}
            handlerDownload={onSuscribeDownloadData}
            showTitle={true}
          />
        </Col>
      </Row>
      <Row className="justify-content-center mt-3">
        <Col className="text-end">
          <p style={{ marginBottom: "0" }}>
            <a
              href="/readysize/products/list"
              className="link-fitprenda-action"
            >
              <FormattedMessage
                id="dashboard-products-seeall"
                //  defaultMessage="Ver todos"
              />
            </a>
          </p>
        </Col>
      </Row>
      <br />
    </>
  );
};

export default DashboardProducts;
